import React, { Component } from 'react'
import { Menu } from 'primereact/menu'
// import { FaBars, FaBell, FaUserAlt } from 'react-icons/fa'
import { FaBars, FaUserAlt } from 'react-icons/fa'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import * as systemActions from '../../store/actions/system.actions'
import * as notificationActions from '../../store/actions/notification.actions'
import { removeToken } from '../../services/localstorage/localstorage.service'
import SelectTps from '../SelectTps/SelectTps'
import './Navbar.css'
import { menuItemsAllowed } from '../../services/permission/menus'

class Navbar extends Component {
  state = { notifications: [] }

  // ***********************************
  // Events
  // ***********************************
  onFabBarsClicked = () => {
    this.props.dispatch(systemActions.showSidebar(true))
  }

  onMenuItemClicked = path => {
    path === '/' && removeToken()
    this.props.history.push(path)
    this.props.dispatch(systemActions.activedPageChange(path))
  }

  removeNotification(index) {
    const notifications = [...this.state.notifications]
    notifications.splice(index, 1)
    this.setState({ notifications })
  }

  onMenuNotificationClicked = (notify, index) => {
    this.removeNotification(index)
    if (notify.delivery_id)
      this.props.dispatch(notificationActions.removeDeliveryNotification(notify.delivery_id))
    else this.props.dispatch(notificationActions.removeFleetNotification(notify.fleet_id))
    this.props.history.push('/main/entregas/chat', {
      fleet_id: notify.fleet_id,
      vehicle_badge: notify.vehicle_plate,
      tp_id: notify.tp_id,
      driver_id: notify.from,
      expected_date: notify.expected_date,
      delivery_id: notify.delivery_id,
      company_name: notify.company,
      weight: notify.weight_total,
    })
  }
  // ***********************************
  // Render
  // ***********************************

  handleClearUnread() {}

  render() {
    const userMenu = (
      <Menu
        model={this._getMenuItems()}
        popup={true}
        ref={el => (this.menu = el)}
        style={{
          top: 50,
          width: 180,
          height: 100,
        }}
      />
    )

    const notifyMenu = (
      <Menu
        model={this._getMenuItemsNotify()}
        popup={true}
        ref={el => (this.menuNotify = el)}
        style={{
          width: '250px',
          maxHeight: '300px',
          overflowY: 'auto',
          borderRadius: '8px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
          fontSize: '0.875rem',
          padding: '0.5rem 0',
        }}
        className="notify-menu"
      />
    )
    return (
      <React.Fragment>
        <nav className="Navbar bck-secondary">
          <div>
            <div className="fabBars__container" onClick={this.onFabBarsClicked}>
              <FaBars color="white" />
            </div>
          </div>
          <div className="leftMenu__container">
            {/* <div
              onClick={event => this.menuNotify.toggle(event)}
              className="nav-item__user notify-icon"
            >
              <FaBell color="white" />
              {this.state.notifications.length > 0 && <span className="notify-badge" />}
            </div> */}
            <div className="nav-item__empresas">
              <SelectTps />
            </div>
            <div onClick={event => this.menu.toggle(event)} className="nav-item__user">
              <FaUserAlt color="white" />
            </div>
          </div>
        </nav>
        {userMenu}
        {notifyMenu}
      </React.Fragment>
    )
  }

  _getMenuItems() {
    return menuItemsAllowed([
      // {
      //   id: 1,
      //   content: {
      //     label: 'Profile',
      //     icon: 'pi pi-fw pi-user',
      //   },
      // },
      // {
      //   id: 2,
      //   content: {
      //     label: 'Configurações',
      //     icon: 'pi pi-fw pi-cog',
      //   },
      // },
      {
        id: 3,
        content: {
          label: 'Sistemas',
          icon: 'pi pi-fw pi-exclamation-triangle',
          command: () => this.onMenuItemClicked('/main/sistema/menu'),
        },
      },
      {
        id: 4,
        content: {
          label: 'Sair',
          icon: 'pi pi-fw pi-power-off',
          command: () => this.onMenuItemClicked('/'),
        },
      },
    ])
  }

  _getMenuItemsNotify() {
    return this.state.notifications.map((not, index) => {
      return {
        label: not.fleet_id
          ? 'Nova mensagem veículo: ' + not.vehicle_plate
          : 'Nova mensagem entrega: ' + not.vehicle_plate,
        icon: 'pi pi-fw pi-exclamation-triangle',
        command: () => {
          this.onMenuNotificationClicked(not, index)
        },
      }
    })
  }
}

export default connect()(withRouter(Navbar))
